module.exports = __webpack_public_path__ + "img/app_store.83ffef1b.png";